<template>
  <textarea class="base-textarea" v-model="localModel" v-bind="$attrs" />
</template>

<script>
export default {
  name: 'BaseTextarea',
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: { type: String, default: '' },
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>

<style>
.base-textarea {
  background: #FFFFFF;
  border: 1px solid #CCD4E0;
  box-sizing: border-box;
  border-radius: 5px;
  height: 35px;
  width: 100%;
  padding: 10px;
  font-size: 14px;
}

.base-textarea::placeholder {
  color: #777;
}

.base-textarea:focus, .base-input:active {
  border-color: #2EA3FF;
  outline: unset;
}
</style>
